

import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./helper/Layout";
import Home from "./pages/Home";
import Resume from "./pages/Resume";
import Skills from "./pages/Skills";
import Blogs from "./pages/Blogs";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/ProjectDetails";
import CustomerReviews from "./pages/CustomerReviews";
import AdminLogin from "./admin/AdminLogin";
import AdminHome from "./admin/AdminHome";
import ProtectedRoute from "./helper/ProtectedRoute";
import AllProjects from "./admin/pages/Management/Projects/AllProjects";
import EditProject from "./admin/pages/Management/Projects/EditProject";
import ProjectImage from "./admin/pages/Management/Projects/ProjectImage";
import ProjectVideo from "./admin/pages/Management/Projects/ProjectVideo";
import WorkWithMe from "./pages/WorkWithMe";
import Dashboard from "./admin/pages/Menu/Dashboard";
import MyCV from "./admin/pages/Menu/MyCV";
import EducationHistory from "./admin/pages/Menu/Educationhistory";
import Workinghistory from "./admin/pages/Menu/Workinghistory";
import SatisfiedClients from "./admin/pages/Myclients/SatisfiedClients";
import WorkWithMeList from "./admin/pages/Supports/WorkWithMeList";
import AdminLayout from "./helper/AdminLayout";
import AdminSkills from "./admin/pages/Menu/Skills";
import BlogManager from "./admin/pages/Management/Blogs/BlogCategory";
import ServiceCRUD from "./admin/pages/Management/Service/Services";
import ContactList from "./admin/pages/Supports/ContactList";

const App = () => {
  return (
    
    <BrowserRouter>
      <Routes>
        {/* Public Pages (Client) */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/my-resume" element={<Layout><Resume /></Layout>} />
        <Route path="/my-blogs" element={<Layout><Blogs /></Layout>} />
        <Route path="/my-skills" element={<Layout><Skills /></Layout>} />
        <Route path="/view-my-projects" element={<Layout><Projects /></Layout>} />
        <Route path="/project-details/:id" element={<Layout><ProjectDetails /></Layout>} />
        <Route path="/customer-review" element={<Layout><CustomerReviews /></Layout>} />
        <Route path="/work-with-me" element={<Layout><WorkWithMe /></Layout>} />

        {/* Admin Login */}
        <Route path="/admin-abhijan-login" element={<AdminLogin />} />

        {/* Admin Panel  */}
        <Route path="/admin-abhijan-home" element={<ProtectedRoute><AdminLayout><AdminHome /></AdminLayout></ProtectedRoute>}>
          <Route index element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="my-cv" element={<ProtectedRoute><MyCV /></ProtectedRoute>} />
          <Route path="my-education" element={<ProtectedRoute><EducationHistory /></ProtectedRoute>} />
          <Route path="my-working-history" element={<ProtectedRoute><Workinghistory /></ProtectedRoute>} />
          <Route path="projects" element={<ProtectedRoute><AllProjects /></ProtectedRoute>} />
          <Route path="projects/:projectId" element={<ProtectedRoute><EditProject /></ProtectedRoute>} />
          <Route path="projects/:projectId/images" element={<ProtectedRoute><ProjectImage /></ProtectedRoute>} />
          <Route path="projects/:projectId/videos" element={<ProtectedRoute><ProjectVideo /></ProtectedRoute>} />
          <Route path="satisfied-clients" element={<ProtectedRoute><SatisfiedClients /></ProtectedRoute>} />
          <Route path="work-with-me-admin" element={<ProtectedRoute><WorkWithMeList /></ProtectedRoute>} />
          <Route path="my-skills-admin" element={<ProtectedRoute><AdminSkills /></ProtectedRoute>} />
          <Route path="my-blogs-admin" element={<ProtectedRoute><BlogManager /></ProtectedRoute>} />
          <Route path="my-services-admin" element={<ProtectedRoute><ServiceCRUD /></ProtectedRoute>} />
          <Route path="my-contact-list-admin" element={<ProtectedRoute><ContactList /></ProtectedRoute>} />
          
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;

